import { render } from "./smallTools.vue?vue&type=template&id=38ee6ca0&scoped=true"
import script from "./smallTools.vue?vue&type=script&lang=js"
export * from "./smallTools.vue?vue&type=script&lang=js"

import "./smallTools.vue?vue&type=style&index=0&id=38ee6ca0&lang=scss&scoped=true"

import exportComponent from "D:\\work\\qianduan\\operation-system\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ee6ca0"]])

export default __exports__